<template>
  <v-layout>
    <global-header />

    <!-- <global-left /> -->

    <v-main>
      <!-- Provides the application the proper gutter -->

      <v-container fluid class="pa-0">
        <v-row class="mx-0">
          <v-col v-if="!mobile" sm="3" cols="12" :style="!mobile ? 'max-width:340px; min-width:340px;' : ''">
            <globalLeft />
          </v-col>
          <v-col>
            <!-- If using vue-router -->
            <slot />
          </v-col>
        </v-row>
      </v-container>
    </v-main>

    <Teleport :to="teleportTo">
      <v-overlay
        v-model="isLoading"
        class="align-center justify-center"
        :persistent="true"
        :close-on-content-click="false"
      >
        <v-progress-circular color="primary" indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <snackbar :show="show"></snackbar>
    </Teleport>

    <global-footer />
  </v-layout>
</template>

<script setup>
useHead({
  meta: [{ name: 'viewport', content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no' }]
})
import globalHeader from '@/layouts/imports/header'
import globalLeft from '@/layouts/imports/left'
import globalFooter from '@/layouts/imports/footer'
import snackbar from '@/layouts/imports/snackbar'
import { useTheme, useDisplay } from 'vuetify'
const { width, mobile } = useDisplay()
const theme = useTheme()

const progressbarStore = useProgressbarStore()
const { isLoading, teleportTo } = storeToRefs(progressbarStore)
const { show } = useSnackbarStore()

// data

// method
theme.global.name.value = 'light'
</script>

<style scoped></style>
